/** GA4 / Firebase Analytics event names (snake_case). */
export const AnalyticsEvents = Object.freeze({
  APP_OPEN: "app_open",
  PWA_INSTALL: "pwa_install",
  APP_UPDATE: "app_update",
  OFFLINE_MODE_ENTERED: "offline_mode_entered",
  OFFLINE_MODE_EXITED: "offline_mode_exited",

  MATCH_CREATED: "match_created",
  MATCH_JOINED: "match_joined",
  MATCH_STARTED: "match_started",
  MATCH_COMPLETED: "match_completed",
  MATCH_ABANDONED: "match_abandoned",

  SHARE_LINK: "share_link",
  SHARE_QR: "share_qr",
  SHARE_NATIVE: "share_native",
  SPECTATOR_OPENED: "spectator_opened",

  UNDO_USED: "undo_used",
  INTERVAL_STARTED: "interval_started",
  GAME_COMPLETED: "game_completed",
  MATCH_POINT: "match_point",
  GAME_POINT: "game_point",

  COURT_SETUP_COMPLETED: "court_setup_completed",
  COURT_SWAPPED: "court_swapped",

  INSTALL_PROMPT_SHOWN: "install_prompt_shown",
  INSTALL_PROMPT_DISMISSED: "install_prompt_dismissed",
  INSTALL_COMPLETED: "install_completed",
  UPDATE_AVAILABLE: "update_available",
  UPDATE_INSTALLED: "update_installed",

  FAILED_ROOM_JOIN: "failed_room_join",
  SYNC_CONFLICT: "sync_conflict",
  FIRESTORE_PERMISSION_DENIED: "firestore_permission_denied",
  OFFLINE_SYNC_FAILED: "offline_sync_failed",
});
